import { Component, OnInit } from '@angular/core';

import { AppComponent } from '../app.component';

@Component({
  standalone: false,
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  langData: any;

  constructor( public app: AppComponent ) {  }

  ngOnInit() {
  }

}
